/* eslint-disable prefer-const */
import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavController } from '@ionic/angular';
import { Multitenant } from '../../../services/multitenant.provider';
import { StorageProvider } from '../../../services/storage.provider';
import { ConfigService } from '../../../services/config.service';
import { Router } from '@angular/router';
import { UrlService } from 'src/app/services/url.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-navheader',
  templateUrl: 'navheader.html',
  styleUrls: ['navheader.scss']
})
export class NavHeaderComponent implements OnInit{
  @Input() navigated: boolean;
  @Input() page: string;
  public logged: boolean;
  public unlogged: boolean;
  public profileName: string;
  public themeClass: string;
  public profileAvatar: string;

  constructor(
    public navCtrl: NavController,
    private router: Router,
    private multiTenant: Multitenant,
    private storage: StorageProvider,
    private config: ConfigService,
    private urlService: UrlService
  ) {
    let accessToken: string;
    let profile: string;
    const url = window.location.href;
    const loginn = url.search('login');

    accessToken = this.storage.getStorage('access_token');
    profile = this.storage.getStorage('logged_profile_id');

    if (loginn !== -1) {
      this.page = 'login';
    }

    if (accessToken && profile) {
      this.logged = true;
      this.unlogged = false;
      this.profileName = this.storage.getStorage('logged_profile_name');
      if (this.storage.getStorage('logged_profile_avatar')) {
        this.profileAvatar = this.storage.getStorage('logged_profile_avatar');
      }
    } else {
      this.logged = false;
      this.unlogged = true;
    }
  }

  isPage() {
    return this.page;
  }

  getProfileNickName() {
    return this.storage.getStorage('logged_profile_nickname');
  }

  goToLogin() {
    if (
      this.themeClass !== 'playbacpresse' &&
      this.themeClass !== 'mwjp' &&
      this.themeClass !== 'mwde' &&
      this.themeClass !== 'clfy' &&
      this.themeClass !== 'mljp' &&
      this.themeClass !== 'mlde'
    ) {
      window.open('https://m-digital.playbacpresse.fr/connexion');
    } else {
      if (this.isPage() !== 'login') {
        this.router.navigate(['connexion'], { queryParams: { page: 'login' } });
      } else {
        this.navCtrl.back();
      }
    }
  }

  goToProfiles() {
    this.router.navigate(['profiles']);
  }

  ngOnInit() {
    this.themeClass = this.multiTenant.getDomainClass();
  }

  goBack() {
    this.urlService.previousUrl$.pipe(take(1)).subscribe({
      next: prevUrl => {
        if (prevUrl) {
          this.navCtrl.back();
        } else {
          this.router.navigate(['']);
        }
      }
    });
  }

  goToBoutique() {
    if (this.themeClass === 'lepq') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-le-petit-quotidien',
        '_blank'
      );
    } else if (this.themeClass === 'mquo') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-mon-quotidien',
        '_blank'
      );
    } else if (this.themeClass === 'actu') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu', '_blank');
    } else if (this.themeClass === 'aeco') {
      window.open('https://www.playbacpresse.fr/abonnements-l-eco', '_blank');
    } else if (this.themeClass === 'mquovideo') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-mon-quotidien-video'
      );
    } else if (this.themeClass === 'actuvideo') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu-video');
    } else if (this.themeClass === 'week') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-weekly',
        '_blank'
      );
    } else if (this.themeClass === 'mwne') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-weeklynews',
        '_blank'
      );
    } else if (this.themeClass === 'sema') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-mi-semanal',
        '_blank'
      );
    } else if (this.themeClass === 'woch') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-meine-woche',
        '_blank'
      );
    } else if (this.themeClass === 'mlwk') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-little-weekly',
        '_blank'
      );
    } else if (this.themeClass === 'mlne') {
      window.open(
        'https://www.playbacpresse.fr/abonnements-my-little-weeklynews',
        '_blank'
      );
    } else if (this.themeClass === 'mwjp') {
      window.open(
        'https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais',
        '_blank'
      );
    } else if (this.themeClass === 'mwde') {
      window.open(
        'https://go.playbacpresse.fr/myweekly-german_2019.html',
        '_blank'
      );
    } else if (this.themeClass === 'mljp') {
      window.open(
        'https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais',
        '_blank'
      );
    } else if (this.themeClass === 'mlde') {
      window.open(
        'https://go.playbacpresse.fr/mylittleweekly-german_2019.html',
        '_blank'
      );
    } else {
      window.open('https://www.playbacpresse.fr', '_blank');
    }
  }

  goHome() {
    this.router.navigate(['']);
  }

  getDefaultAvatar(): string {
    const avatar = this.config.getDefaultAvatar();
    return avatar[this.storage.getStorage('logged_profile_type')];
  }
}
